import { ref } from "vue";
import { useToast } from "primevue/usetoast";

export function useVideoPlayback() {
  const toast = useToast();
  const currentlyPlayingId = ref(null);

  const setPlaying = (id) => {
    currentlyPlayingId.value = id;
  };

  const copyLink = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      toast.add({
        severity: "success",
        summary: "Copied",
        detail: "Link copied to clipboard.",
        life: 3000,
      });
    } catch (error) {
      console.error("Error copying link:", error);
      toast.add({
        severity: "error",
        summary: "Error",
        detail: "Failed to copy link.",
        life: 4000,
      });
    }
  };

  return { currentlyPlayingId, setPlaying, copyLink };
}
